import React from "react";
import { FaArrowCircleUp } from "react-icons/fa";
import { Link } from "gatsby";
import MaxWidthWrapper from "../common/MaxWidthWrapper";
import SecondaryWidthWrapper from "../common/SecondaryWidthWrapper";

interface Props {
  html: string;
}

const BlogHtmlContent: React.FC<Props> = ({ html }) => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <MaxWidthWrapper>
      <SecondaryWidthWrapper>
        <div className="mb-10 flex flex-col gap-5 lg:mb-16 lg:flex-row">
          {/* Content */}
          <div className="grow">
            <div
              className="prose prose-sm max-w-none lg:prose-base xl:prose-lg prose-headings:text-green-900 prose-p:text-gray-700 prose-strong:text-green-900 prose-a:text-primary hover:prose-a:text-green-700 prose-img:rounded-lg prose-img:shadow-md prose-table:border-collapse prose-table:border prose-table:border-gray-300 prose-th:border prose-th:border-gray-300 prose-th:bg-gray-100 prose-th:p-2 prose-td:border prose-td:border-gray-300 prose-td:p-2"
              dangerouslySetInnerHTML={{ __html: html }}
            />
          </div>

          <div className="flex flex-col gap-5 lg:sticky lg:top-24 lg:self-start">
            <div className="flex h-72 w-full shrink-0 flex-col justify-evenly rounded-2xl bg-primary p-12 lg:w-80">
              <p className="text-lg text-white">
                Need an expert team to provide digital solutions for your
                business?
              </p>
              <Link
                to={"#blogs-details-contact"}
                className="w-fit rounded-full bg-black px-6 py-2 text-white"
              >
                Book A Free Call
              </Link>
            </div>

            <div
              onClick={scrollToTop}
              className="hidden cursor-pointer items-center justify-center gap-3 rounded-xl border border-solid border-opacity-20 bg-gray-100 py-3 text-gray-700 text-opacity-50 lg:flex"
            >
              Return Back
              <FaArrowCircleUp className="text-primary" size={20} />
            </div>
          </div>
        </div>
      </SecondaryWidthWrapper>
    </MaxWidthWrapper>
  );
};

export default BlogHtmlContent;
